import React, { useState, useEffect, useCallback, useContext } from "react";
// ===== MUI core (use default imports from component paths) =====
import Tooltip from "@mui/material/Tooltip";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Zoom from "@mui/material/Zoom";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import InsightsIcon from "@mui/icons-material/Insights";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import PsychologyIcon from "@mui/icons-material/Psychology";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import TokenIcon from "@mui/icons-material/Token";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CelebrationIcon from "@mui/icons-material/Celebration";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import RefreshIcon from "@mui/icons-material/Refresh";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import EditIcon from "@mui/icons-material/Edit";
import AdminTokenLedgerPanel from "./AdminTokenLedgerPanel.js";
import MetricsDiffDashboard from "./MetricsDiffDashboard";
import "./Admin.css";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { Line } from "react-chartjs-2";
import "chart.js/auto"; // Import Chart.js
import { db } from "../utils/firebase";
import {
  doc,
  deleteDoc,
  updateDoc,
  collection,
  query,
  where,
  getDoc,
  setDoc,
  getDocs,
  orderBy,
} from "firebase/firestore";
import { useColorMode } from "../ColorModeContext";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip as ChartTooltip,
  Legend,
} from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import { useNavigate } from "react-router-dom";
import { logout } from "../utils/firebase";
import { useAuth } from "./AuthContext";
import DeleteAccount from "./DeleteAccount";
import ConversationRecord from "./ConversationRecord";
import { TokenContext } from "./tokenContext"; // import TokenContext
import GlobalNavDrawer from "../components/GlobalNavDrawer";
import PilotManager from "./PilotManager";

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    ChartTooltip,
    Legend,
    zoomPlugin
  );

function Admin() {
  const { balance } = useContext(TokenContext);
  const [questions, setQuestions] = useState([]);
  const [user, setUser] = useState(null);
  const { colorMode, changeColorMode } = useColorMode();
  const navigate = useNavigate();
  const [selectedQuestion, setSelectedQuestion] = useState("");
  const { userRole, username } = useAuth();
  const isVoiceBot = (username?.trim?.().toLowerCase() === "voicebot") || (user?.displayName?.trim?.().toLowerCase() === "voicebot");
  const [userIds, setUserIds] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [questionResponses, setQuestionResponses] = useState([]);
  const [open, setOpen] = useState(false);
  const [documentIds, setDocumentIds] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const handleClose = () => setOpen(false);
  const [tokenIncrement, setTokenIncrement] = useState(0);
  const [reasonToChangeTs, setReasonToChangeTs] = useState("");
  const [newRole, setNewRole] = useState("");
  const [roleUpdated, setRoleUpdated] = useState(false);
  const [selectedUserRole, setSelectedUserRole] = useState("");
  const [loggedInUserTokens, setLoggedInUserTokens] = useState(0);
  const [selectedUserTokens, setSelectedUserTokens] = useState(0);
  const [saving, setSaving] = useState(false);
  const [chargeHouseToggle, setChargeHouseToggle] = useState(false);
  const [inPilot, setInPilot] = useState(false);
  const [activePilot, setActivePilot] = useState(null);
  const [documentData, setDocumentData] = useState({
    date: "",
    response: "",
    responseAnalysis: "",
    responseTime: "",
    charRatio: "",
    score: "",
  });
  const [chartData, setChartData] = useState({
    labels: [], // for dates
    datasets: [
      {
        label: "Average Score",
        data: [], // for average scores
        borderColor: "rgb(75, 192, 192)",
        tension: 0.1,
      },
    ],
  });
  const options = {
    tooltips: {
      enabled: true,
      mode: "index",
      intersect: false,
      callbacks: {
        label: function (tooltipItem, data) {
          let label = data.datasets[tooltipItem.datasetIndex].label || "";
          if (label) {
            label += ": ";
          }
          label += Math.round(tooltipItem.yLabel * 100) / 100;
          return label;
        },
      },
    },
    scales: {
      y: {
        grid: {
          color: "rgba(255,255,255,0.15)",
          borderColor: "green",
          borderDash: [5, 5],
          lineWidth: 2,
          drawBorder: true,
          drawOnChartArea: true,
          drawTicks: true,
          tickColor: "green",
          tickLength: 10,
        },
        ticks: {
          color: getComputedStyle(document.documentElement)
    .getPropertyValue("--text")
        },
        title: {
          display: true,
          text: "Score",
          color: "white",
        },
      },
      x: {
        grid: {
          color: "rgba(255,255,255,0.15)",
          borderColor: "red",
          borderDash: [3, 3],
          lineWidth: 1,
          drawBorder: true,
          drawOnChartArea: true,
          drawTicks: true,
          tickColor: "red",
          tickLength: 8,
        },
        ticks: {
          color: getComputedStyle(document.documentElement)
    .getPropertyValue("--text")
        },
        title: {
          display: true,
          text: "Answer Date",
          color: "white",
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          color: "orange",
        },
      },
      title: {
        display: true,
        text: "Interview Question Score",
        color: "white",
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "xy",
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          pinch: {
            enabled: true,
          },
          mode: "xy",
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  // Toasts
  const [toast, setToast] = useState({ open: false, msg: "" });
  const showToast = (msg) => setToast({ open: true, msg });
  const closeToast = () => setToast({ open: false, msg: "" });

  // SpeedDial + Help dialog + Wild mode
  const [dialOpen, setDialOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [wild, setWild] = useState(false);

  // === Pilot Banner Logic ===
  useEffect(() => {
    // Fetch the currently active pilot from the new /api/pilots endpoint
    fetch("https://fluency.ispeakwell.ca/api/pilots")
      .then((r) => r.json())
      .then((list) => {
        const current = list.find((p) => p.active);
        setActivePilot(current || null);
      })
      .catch((err) => console.error("Admin: pilot fetch error", err));
  }, []);

  useEffect(() => {
    // Check if current user (admin) is recorded as in a pilot
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) return;

    getDoc(doc(db, "users", user.uid, "pilotConsent", "info"))
      .then((snap) => {
        if (snap.exists() && snap.data().consentGiven) {
          setInPilot(true);
        }
      })
      .catch((err) => console.error("Admin: consent check error", err));
  }, []);

  useEffect(() => {
    document.body.classList.toggle("wild", wild);
  }, [wild]);

  const handleCopyUserId = async () => {
    if (!selectedUserId) return showToast("No user selected");
    try {
      await navigator.clipboard.writeText(selectedUserId);
      showToast("User ID copied");
    } catch {
      showToast("Copy failed");
    }
  };

  const scrollToResponses = () => {
    const el = document.querySelector(".panel-responses");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const triggerConfetti = () => {
    const emojis = ["🎉", "✨", "💥", "🪙", "🚀", "🌈", "🎈", "⭐"];
    for (let i = 0; i < 28; i++) {
      const span = document.createElement("span");
      span.className = "confetti-emoji";
      span.textContent = emojis[Math.floor(Math.random() * emojis.length)];
      span.style.left = Math.random() * 100 + "vw";
      span.style.animationDelay = Math.random() * 0.3 + "s";
      span.style.fontSize = 12 + Math.random() * 24 + "px";
      document.body.appendChild(span);
      setTimeout(() => span.remove(), 2000);
    }
  };

  // Keyboard shortcuts: Ctrl/Cmd+K (help), "g" then "r" (responses), "w" (wild mode)
  useEffect(() => {
    let lastKey = null;
    let keyTimer = null;

    const onKey = (e) => {
      const tag = (e.target?.tagName || "").toLowerCase();
      const inField = tag === "input" || tag === "textarea" || e.target?.isContentEditable;

      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setHelpOpen(true);
        return;
      }

      if (!inField && e.key.toLowerCase() === "w") {
        setWild((v) => !v);
        showToast(`Wild mode ${!wild ? "ON" : "OFF"}`);
      }

      if (!inField && lastKey === "g" && e.key.toLowerCase() === "r") {
        scrollToResponses();
      }

      lastKey = e.key.toLowerCase();
      clearTimeout(keyTimer);
      keyTimer = setTimeout(() => (lastKey = null), 650);
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wild]);


  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      if (currentUser && userRole !== "admin") {
        setSelectedUserId(currentUser.uid);
      }
    });
    return () => {
      unsubscribe(); // This function is called when the component unmounts
      // Clear user data here as well, to handle component unmounting
      setQuestions([]);
      setUserIds([]);
      setQuestionResponses([]);
      setDocumentIds([]);
      setSelectedId("");
      setDocumentData({}); // Reset to the initial state of your document data
      // Add more state resets as needed
    };
  }, [navigate, userRole]);

  useEffect(() => {
    const fetchLoggedInUserTokens = async () => {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (currentUser) {
        const userRef = doc(db, "users", currentUser.uid);
        try {
          const userDoc = await getDoc(userRef);
          if (userDoc.exists()) {
            setLoggedInUserTokens(userDoc.data().tokens || 0);
          }
        } catch (error) {
          console.error("Error fetching token count: ", error);
        }
      }
    };

    fetchLoggedInUserTokens();
  }, [user]); // Dependency on the logged-in user

  const fetchUserDetails = useCallback(async () => {
    if (!selectedUserId || userRole !== "admin") return;

    const userRef = doc(db, "users", selectedUserId);
    try {
      const userDoc = await getDoc(userRef);
      if (userDoc.exists()) {
        setSelectedUserTokens(userDoc.data().tokens || 0);
        setSelectedUserRole(userDoc.data().role || "user");
      } else {
        setSelectedUserTokens(0);
        setSelectedUserRole("user");
      }
    } catch (error) {
      console.error("Error fetching user details: ", error);
    }
  }, [selectedUserId, userRole]);

  useEffect(() => {
    fetchUserDetails();
  }, [fetchUserDetails, userRole]);

  useEffect(() => {
    if (!user) return;
    // Fetching user IDs (for admin role)
    async function fetchUserIds() {
      if (userRole === "admin") {
        const usersCollection = collection(db, "users");
        const userDocs = await getDocs(usersCollection);
        const userIds = userDocs.docs.map((doc) => doc.id);
        setUserIds(userIds);

        // Optionally, set a default selectedUserId here, e.g., the first one
        if (userIds.length > 0 && !selectedUserId) {
          setSelectedUserId(userIds[0]);
        }
      }
    }

    if (userRole === "admin") {
      fetchUserIds();
    }
  }, [selectedUserId, userRole, user, roleUpdated]);

  async function resetMfaFactors(targetUid) {
    const token = await getAuth().currentUser?.getIdToken();
    const r = await fetch("https://fluency.ispeakwell.ca/api/admin/reset-mfa", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
      body: JSON.stringify({ targetUid }),
    });
    const json = await r.json().catch(() => ({}));
    if (!r.ok || !json.ok) {
      throw new Error(json.error || `${r.status} ${r.statusText}`);
    }
    return json;
  }

  async function listMfaFactors(targetUid) {
    const token = await getAuth().currentUser?.getIdToken();
    const r = await fetch("https://fluency.ispeakwell.ca/api/admin/list-mfa", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
      body: JSON.stringify({ targetUid }),
    });
    const json = await r.json().catch(() => ({}));
    if (!r.ok || !json.ok) {
      throw new Error(json.error || `${r.status} ${r.statusText}`);
    }
    return json.factors; // array of enrolled factors
  }

  const fetchQuestions = useCallback(async () => {
    if (!user) return;

    let userIdToFetch =
      userRole === "admin" && selectedUserId ? selectedUserId : user?.uid;

    if (userIdToFetch) {
      try {
        const responsesQuery = query(
          collection(db, "users", userIdToFetch, "userResponses")
        );
        const querySnapshot = await getDocs(responsesQuery);

        const uniqueQuestions = new Set();
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          uniqueQuestions.add(data.questionText);
        });

        setQuestions(Array.from(uniqueQuestions));
      } catch (error) {
        console.error("Error fetching questions:", error);
        setQuestions([]);
      }
    }
  }, [user, userRole, selectedUserId]); // Dependencies of fetchQuestions

  useEffect(() => {
    if (!user) return;
    async function fetchData() {
      let userIdToFetch = user && user.uid;

      if (userRole === "admin" && selectedUserId) {
        userIdToFetch = selectedUserId;
      }

      if (selectedQuestion && userIdToFetch) {
        const q = query(
          collection(db, "users", userIdToFetch, "userResponses"),
          where("questionText", "==", selectedQuestion)
        );
        const querySnapshot = await getDocs(q);

        const scoresByDate = {};
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          const score = parseFloat(data.score);
          const date = data.date ? new Date(data.date) : null;

          if (!isFinite(score) || !date || isNaN(date)) return;

          const dateStr = date.toISOString().split("T")[0];
          if (!scoresByDate[dateStr]) scoresByDate[dateStr] = [];
          scoresByDate[dateStr].push(score);
        });

        const labels = Object.keys(scoresByDate).sort();
        const averages = labels.map((date) => {
          const scores = scoresByDate[date];
          const avg = scores.reduce((acc, s) => acc + s, 0) / scores.length;
          return Number(avg.toFixed(2));
        });
        console.log(averages, labels);

        // ✅ Handle single-point visibility
        setChartData({
          labels,
          datasets: [
            {
              label: "Average Score",
              data: averages,
              borderColor: "rgb(75,192,192)",
              backgroundColor: "rgba(75,192,192,0.4)",
              tension: 0.3,
              pointRadius: averages.length === 1 ? 6 : 3,
              pointHoverRadius: 8,
              showLine: averages.length > 1,
            },
          ],
        });
      }
    }
    if (user) {
      fetchData();
    }
  }, [selectedQuestion, selectedUserId, userRole, user]);

  useEffect(() => {
    if (!user) return;
    setQuestionResponses([]);

    async function fetchResponses() {
      let userIdToFetch = userRole === "admin" ? selectedUserId : user.uid;
      if (userIdToFetch && selectedQuestion) {
        const q = query(
          collection(db, "users", userIdToFetch, "userResponses"),
          where("questionText", "==", selectedQuestion),
          orderBy("date", "desc")
        );
        const querySnapshot = await getDocs(q);
        const responses = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          responses.push({
            id: doc.id,
            date: data.date,
            response: data.userResponse,
            responseAnalysis: data.responseAnalysis,
            responseTime: data.responseTime,
            charRatio: data.charRatio,
            score: data.score,
            // Make sure this line correctly references the field in Firestore
            // Add more fields here if needed
          });
        });
        setQuestionResponses(responses);
        console.log("Chart filter:", JSON.stringify(selectedQuestion));
        console.log("Responses:", JSON.stringify(responses));
      }
    }

    fetchResponses();
  }, [selectedQuestion, user, selectedUserId, userRole]);

  const fetchDocumentIds = useCallback(async () => {
    if (!user) return;
    let userIdToFetch =
      userRole === "admin" && selectedUserId ? selectedUserId : user?.uid;

    if (userIdToFetch) {
      try {
        let q;
        if (selectedQuestion) {
          q = query(
            collection(db, "users", userIdToFetch, "userResponses"),
            where("questionText", "==", selectedQuestion)
          );
        } else {
          q = query(collection(db, "users", userIdToFetch, "userResponses"));
        }

        const querySnapshot = await getDocs(q);
        const ids = querySnapshot.docs.map((doc) => doc.id);
        setDocumentIds(ids);
      } catch (error) {
        console.error("Error fetching document IDs:", error);
        console.log("Error details:", error.code, error.message);
      }
    }
  }, [user, selectedQuestion, selectedUserId, userRole]);

  useEffect(() => {
    fetchDocumentIds();
  }, [fetchDocumentIds]); // Fetch document IDs when these dependencies change

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions, selectedQuestion, user]); // Update the list of questions when these dependencies change

  const handleRoleUpdate = async () => {
    if (!selectedUserId || !newRole) {
      alert("Please select a user and a role.");
      return;
    }

    if (user && selectedUserId === user.uid) {
      alert("You cannot change your own role.");
      return;
    }

    try {
      const userRef = doc(db, "users", selectedUserId);
      await updateDoc(userRef, { role: newRole });
      alert("User role updated successfully");
      // Reset the state or perform any additional actions
      setNewRole("");
      setRoleUpdated((prev) => !prev);
    } catch (error) {
      console.error("Error updating user role: ", error);
      alert("Failed to update user role.");
    }
  };

  if (!user) {
    return <div>Loading or not authorized...</div>;
  }

  const handleIdChange = async (event) => {
    if (!user) return;

    const id = event.target.value;
    setSelectedId(id);

    try {
      const userIdToFetch = userRole === "admin" ? selectedUserId : user.uid;
      const docRef = doc(db, "users", userIdToFetch, "userResponses", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setDocumentData(docSnap.data());
      } else {
        console.log("No such document!");
        setDocumentData({}); // Reset the document data if not found
      }
    } catch (error) {
      console.error("Error fetching document:", error);
    }
  };

  const handleDelete = async () => {
    if (!user) return;
    if (!selectedId) {
      console.error("No document selected");
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to delete this document?"
    );
    if (!confirmed) {
      return;
    }

    try {
      const docRef = doc(
        db,
        "users",
        selectedUserId,
        "userResponses",
        selectedId
      );
      await deleteDoc(docRef);
      const confirmed = window.confirm("Document successfully deleted.");
      if (!confirmed) {
        return;
      }

      // Refresh the list of document IDs
      await fetchDocumentIds();
      await fetchQuestions();

      // Reset the selected ID and document data
      setSelectedId("");
      setDocumentData({}); // Reset to the initial state of your document data
    } catch (error) {
      const confirmed = window.confirm("Can't delete document.");
      if (!confirmed) {
        return;
      }
    }
  };

  // Function to fetch document IDs (similar to what's used in useEffect)

  const handleSave = async () => {
    if (!user) return;
    if (!selectedId) {
      console.error("No document selected");
      // Handle the case where no document is selected
      return;
    }

    try {
      const docRef = doc(
        db,
        "users",
        selectedUserId,
        "userResponses",
        selectedId
      );
      await updateDoc(docRef, documentData);
      console.log("Document successfully updated");
      handleClose();
    } catch (error) {
      console.error("Error updating document:", error);
      // Handle any errors, such as displaying an error message
    }
  };

  
  const handleQuestionChange = async (event) => {
    if (!user) return;
    const question = event.target.value;
    setSelectedQuestion(question);

    let userIdToFetch = userRole === "admin" ? selectedUserId : user.uid;
    if (userIdToFetch && question) {
      try {
        // Query Firestore to fetch document IDs based on the selected question
        const q = query(
          collection(db, "users", userIdToFetch, "userResponses"),
          where("questionText", "==", question)
        );
        const querySnapshot = await getDocs(q);
        const ids = querySnapshot.docs.map((doc) => doc.id);
        // Set the state with the fetched document IDs
        setDocumentIds(ids);
      } catch (error) {}
    }
    setSelectedId("");
    setDocumentData({});
  };

  function formatMillis(millis) {
    const minutes = Math.floor(millis / 60000);
    const seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
  }

  const reviseUserQuestionResponse = () => {
    setOpen(true);
  };

  function convertUtcToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toLocaleString(); // Converts to local time and formats it
  }

  function formatCharRatio(ratio) {
    return parseFloat(ratio).toFixed(2);
  }

  const changeColor = async () => {
    if (!user || !user.uid) {
      console.error("user or user.uid is undefined");
      return;
    }

    const newColorMode = colorMode >= 17 ? 0 : colorMode + 1;
    // Reference to the user's color mode document
    const colorModeRef = doc(
      db,
      "users",
      user.uid,
      "userColorMode",
      "colorDocument"
    );
    // Try to get the document
    const docSnap = await getDoc(colorModeRef);
    // Check if the document exists
    if (!docSnap.exists()) {
      // If it doesn't exist, create it with the initial color mode
      await setDoc(colorModeRef, { colorMode: newColorMode });
    } else {
      // If it exists, update the color mode
      await updateDoc(colorModeRef, { colorMode: newColorMode });
    }

    changeColorMode(newColorMode);
  };


// Admin.js (inside your Admin-only component)
async function adjustTokens({ targetUid, delta, reason, note, chargeHouse = false }) {
  const token = await getAuth().currentUser?.getIdToken();
  const r = await fetch("https://fluency.ispeakwell.ca/api/admin/tokens/adjust", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify({
      targetUid,
      delta: Number(delta),            // positive = credit, negative = debit
      reason: reason || "error_correction",
      note: note || "",
      chargeHouse                       // optional: if true, offset tokens from HOUSE_UID
    }),
    credentials: "include",             // if your auth cookie/session is used
  });

  const json = await r.json().catch(() => ({}));
  if (!r.ok || !json.ok) {
    throw new Error(json.error || `${r.status} ${r.statusText}`);
  }
  return json; // { ok, target: { before, after }, house?: { before, after }, entryId }
}

async function onAdjustClick() {
  try {
    if (!selectedUserId) throw new Error("No user selected");
    if (!tokenIncrement || Number(tokenIncrement) === 0) throw new Error("Enter a non-zero amount");
    setSaving(true);

    const res = await adjustTokens({
      targetUid: selectedUserId,
      delta: Number(tokenIncrement),              // +25 to add, -10 to remove
      reason: (reasonToChangeTs || "").trim(),    // reuse your reason field
      note: "",                                   // add a note field later if you want
      chargeHouse: chargeHouseToggle,             // optional treasury offset
    });

    // update the visible balance
    if (typeof res?.target?.after === "number") {
      setSelectedUserTokens(res.target.after);
    }

    // confetti and toast
    if (typeof triggerConfetti === "function") triggerConfetti();
    (window.toast?.success
      ? window.toast.success
      : (msg) => console.log("SUCCESS:", msg)
    )(`New balance: ${res.target.after} tok`);

    // optional: reset amount
    // setTokenIncrement(0);
  } catch (e) {
    (window.toast?.error
      ? window.toast.error
      : (msg) => console.error("ERROR:", msg)
    )(e?.message || "Adjustment failed");
  } finally {
    setSaving(false);
  }
}

  return (
    <div className="admin-shell">
      {/* Top Bar */}
      <header className="admin-topbar">
        <div className="brand">
          <h1>iSpeakWell</h1>
          <span className="tagline">Admin</span>
        </div>

        <div className="topbar-right">
          <Tooltip title="Your tokens">
            <div className="token-pill">🪙 {loggedInUserTokens}</div>
          </Tooltip>

          <Tooltip title="Change Theme">
            <IconButton onClick={changeColor} aria-label="Change theme">
              {((colorMode ?? 0) % 2 === 0) ? <DarkModeIcon /> : <LightModeIcon />}
            </IconButton>
          </Tooltip>

          <Tooltip title={wild ? "Disable Wild Mode (W)" : "Enable Wild Mode (W)"}>
            <IconButton onClick={() => setWild((v) => !v)} aria-label="Wild mode">
              <AutoAwesomeIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Reload">
            <IconButton onClick={() => window.location.reload()} aria-label="Reload">
              <RefreshIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Help (Ctrl/Cmd + K)">
            <IconButton onClick={() => setHelpOpen(true)} aria-label="Help">
              <HelpOutlineIcon />
            </IconButton>
          </Tooltip>
        </div>
      </header>

      {/* Left Drawer (mobile nav) */}
        <GlobalNavDrawer
            hideCurrent
            links={[
              {to: "/purchase", label: `Tokens: ${balance}`},
              { to: "/voicebot", label: "iSpeakWell" },
              { to: "/resumerevisor", label: "Resumes" },
              { to: "/conversationpractice", label: "Convos" },
              { to: "/interview-practice", label: "Interviews" },
              { to: "/termsofservice", label: "Terms" },
              { to: "/privacypolicy", label: "Privacy" },
              { to: "/login", label: "Logout", onClick: async () => { await logout(); } },
            ]}
        />

      {/* Main Grid */}
      <main className="admin-grid">
        {/* Filters & Quick Actions */}
        <section className="panel panel-filters tilt">
          <h3 className="panel-title icon-title">
            <PsychologyIcon /> Controls
          </h3>

          {userRole === "admin" && (
            <div className="field">
              <label className="label">User ID</label>
              <select
                className="select"
                value={selectedUserId}
                onChange={(e) => setSelectedUserId(e.target.value)}
              >
                {userIds.map((id) => (
                  <option key={id} value={id}>
                    {id === user.uid ? `★ ${id}` : id}
                  </option>
                ))}
              </select>
              <div className="row gap" style={{ marginTop: 8 }}>
                <Tooltip title="Copy selected User ID">
                  <button className="btn" onClick={handleCopyUserId}>
                    <ContentCopyIcon style={{ verticalAlign: "middle", marginRight: 6 }} />
                    Copy
                  </button>
                </Tooltip>
              </div>
            </div>
          )}

          <div className="field">
            <label className="label">Interview Question</label>
            <select className="select" onChange={handleQuestionChange} value={selectedQuestion}>
              {questions.length > 0 ? (
                questions.map((q, i) => (
                  <option key={i} value={q}>
                    {q}
                  </option>
                ))
              ) : (
                <option value="" disabled>
                  No questions answered
                </option>
              )}
            </select>
          </div>

          {userRole === "admin" && selectedUserId && (
            <div className="mini-stats">
              <div className="stat">
                <div className="stat-label">Selected User</div>
                <div className="stat-value mono row gap" style={{ alignItems: "center" }}>
                  <ManageAccountsIcon fontSize="small" />
                  {selectedUserId.slice(0, 6)}…{selectedUserId.slice(-4)}
                </div>
              </div>
              <div className="stat">
                <div className="stat-label">Tokens</div>
                <div className="stat-value row gap" style={{ alignItems: "center" }}>
                  <TokenIcon fontSize="small" /> {selectedUserTokens}
                </div>
              </div>
              <div className="stat">
                <div className="stat-label">Role</div>
                <div className="stat-value">{selectedUserRole}</div>
              </div>
            </div>
          )}

          <Tooltip title="Try different vibes">
            <button className="btn full" onClick={changeColor}>
              <AutoAwesomeIcon style={{ verticalAlign: "middle", marginRight: 6 }} />
              Change Color Theme {colorMode + 1}
            </button>
          </Tooltip>
        </section>

        {/* Performance Chart */}
        <section className="panel panel-chart tilt">
          <h3 className="panel-title icon-title">
            <InsightsIcon /> Performance Over Time
          </h3>
        <div className="chart-wrapper">
          {chartData.labels.length === 0 ? (
            <span className="panel-subtle">No data for this question yet</span>
          ) : (
            <Line
              data={chartData}
              options={options}
            />
          )}
        </div>
          <div className="panel-subtle">Tip: Scroll to zoom, drag to pan.</div>
        </section>

        {/* Conversation Record */}
        <section className="panel panel-conversation tilt">
          <h3 className="panel-title icon-title">
            <QuestionAnswerIcon /> Conversation Record
          </h3>
          <div className="conversation-wrapper">
            <ConversationRecord />
          </div>
        </section>

        {/* Responses */}
        <section className="panel panel-responses tilt">
          <div className="panel-header-row">
            <h3 className="panel-title icon-title">
              <PsychologyIcon /> Responses
            </h3>
            {userRole === "admin" && (
              <Tooltip title="Revise selected response">
                <button className="btn ghost" onClick={reviseUserQuestionResponse}>
                  <EditIcon style={{ verticalAlign: "middle", marginRight: 6 }} />
                  Revise
                </button>
              </Tooltip>
            )}
          </div>

          <div className="responses-scroller">
            {questionResponses.length === 0 ? (
              <div className="empty-hint">No responses for this question yet.</div>
            ) : (
              questionResponses.map((response) => (
                <article key={response.id} className="response-card">
                  <div className="response-meta">
                    <span className="mono id">ID: {response.id}</span>
                    <span>{convertUtcToLocalTime(response.date)}</span>
                    <span>⏱ {formatMillis(response.responseTime)}</span>
                    <span className="score-pill" title="Score">{response.score}</span>
                  </div>
                  <div className="response-body">
                    <p><strong>Response</strong> — {response.response}</p>
                    <p><strong>Analysis</strong> — {response.responseAnalysis}</p>
                    <p><strong>Typed ↔ Spoken Ratio</strong> — {formatCharRatio(response.charRatio)}</p>
                  </div>
                </article>
              ))
            )}
          </div>
        </section>

        {/* Tools */}
        <section 
          className="panel panel-tools tilt">
          <h3 className="panel-title icon-title">
            <ManageAccountsIcon /> Admin Tools
          </h3>

          {isVoiceBot && (
            <div className="card">
              <h4 className="section-label">Increment Selected User Tokens</h4>

              <div className="row gap">
                <input
                  className="input number"
                  type="number"
                  value={tokenIncrement}
                  onChange={(e) => setTokenIncrement(parseInt(e.target.value, 10) || 0)}
                  placeholder="Amount"
                />
                <Tooltip title="Apply token change">
                  <span>
                    <button
                      className="btn"
                      onClick={onAdjustClick}
                      disabled={saving || !tokenIncrement || !selectedUserId}
                    >
                      <TokenIcon style={{ verticalAlign: "middle", marginRight: 6 }} />
                      {saving ? "Saving..." : (tokenIncrement < 0 ? "Remove" : "Add")} Tokens
                    </button>
                  </span>
                </Tooltip>
              </div>

              {/* Optional treasury offset */}
              <label className="row" style={{ gap: 8, marginTop: 8 }}>
                <input
                  type="checkbox"
                  checked={chargeHouseToggle}
                  onChange={(e) => setChargeHouseToggle(e.target.checked)}
                />
                <span className="hint">Charge House/Treasury (offset the adjustment)</span>
              </label>

              <input
                className="input"
                type="text"
                value={reasonToChangeTs}
                onChange={(e) => setReasonToChangeTs(e.target.value)}
                placeholder="Reason for change (e.g., error correction, testing)"
                style={{ marginTop: 8 }}
              />

              <div className="mini-stats compact">
                <div className="stat">
                  <div className="stat-label">User Tokens</div>
                  <div className="stat-value">{selectedUserTokens}</div>
                </div>
              </div>

              <div className="divider" />

              <h4 className="section-label">Manage User Role</h4>
              <div className="row gap">
                <select className="select" value={newRole} onChange={(e) => setNewRole(e.target.value)}>
                  <option value="">Select Role</option>
                  <option value="admin">Admin</option>
                  <option value="user">User</option>
                </select>
                <Tooltip title="Update role">
                  <button className="btn" onClick={handleRoleUpdate}>
                    <ManageAccountsIcon style={{ verticalAlign: "middle", marginRight: 6 }} />
                    Update Role
                  </button>
                </Tooltip>
              </div>
              <div className="hint">Current role: {selectedUserRole}</div>

              <div className="divider" />
                <h4 className="section-label">Security Tools</h4>
                {userRole === "admin" && selectedUserId && (
                <div className="row gap">
                  <Tooltip title="Clear all MFA factors for this user">
                    <button
                      className="btn danger"
                      onClick={async () => {
                        try {
                          const res = await resetMfaFactors(selectedUserId);
                          alert(res.message || "MFA reset successful");
                        } catch (e) {
                          alert("MFA reset failed: " + e.message);
                        }
                      }}
                    >
                      Reset MFA Factors
                    </button>
                  </Tooltip>

                  <Tooltip title="List current MFA factors for this user">
                    <button
                      className="btn"
                      onClick={async () => {
                        try {
                          const factors = await listMfaFactors(selectedUserId);
                          if (!factors.length) {
                            alert("No factors enrolled");
                          } else {
                            alert("Factors:\n" + factors.map(f => `${f.factorId} (${f.displayName || f.factorType})`).join("\n"));
                          }
                        } catch (e) {
                          alert("List factors failed: " + e.message);
                        }
                      }}
                    >
                      List MFA Factors
                    </button>
                  </Tooltip>
                </div>      
              )}
              <div className="divider" />
                <div>
                  <MetricsDiffDashboard />
                </div>
              
              </div>
          )}
          <div className="card">
            <DeleteAccount />
          </div>
          {userRole === "admin" &&
          <div className="card"> 
            <AdminTokenLedgerPanel />
          </div> }
        </section>
        {isVoiceBot && (
          <section className="panel pilot-manager tilt">
            <div className="pilot-manager-card">
              <PilotManager />
            </div>
            <div className="divider" />
          </section>
        )}
        {inPilot && activePilot && (
          <div className="pilot-banner">
            🧭 You are participating in {activePilot.name} (
            {new Date(activePilot.startAt._seconds * 1000).toLocaleDateString()} –{" "}
            {new Date(activePilot.endAt._seconds * 1000).toLocaleDateString()})
          </div>
        )}
      </main>
        
      {/* SpeedDial (macro-interactions) */}
      <div className="fab-dial">
        <SpeedDial
          ariaLabel="Quick actions"
          icon={<RocketLaunchIcon />}
          onClose={() => setDialOpen(false)}
          onOpen={() => setDialOpen(true)}
          open={dialOpen}
          direction="up"
        >
          <SpeedDialAction
            icon={<AutoAwesomeIcon />}
            tooltipTitle="Change Theme"
            onClick={changeColor}
          />
          <SpeedDialAction
            icon={<QuestionAnswerIcon />}
            tooltipTitle="Go to Responses"
            onClick={scrollToResponses}
          />
          <SpeedDialAction
            icon={<ContentCopyIcon />}
            tooltipTitle="Copy User ID"
            onClick={handleCopyUserId}
          />
          <SpeedDialAction
            icon={<CelebrationIcon />}
            tooltipTitle="Confetti!"
            onClick={triggerConfetti}
          />
          <SpeedDialAction
            icon={<HelpOutlineIcon />}
            tooltipTitle="Help (Ctrl/Cmd + K)"
            onClick={() => setHelpOpen(true)}
          />
        </SpeedDial>
      </div>

      {/* Help / Shortcuts Dialog */}
      <Dialog open={helpOpen} onClose={() => setHelpOpen(false)} maxWidth="sm" fullWidth TransitionComponent={Zoom}>
        <DialogTitle>
          <KeyboardIcon style={{ verticalAlign: "middle", marginRight: 6 }} />
          Quick shortcuts
        </DialogTitle>
        <DialogContent dividers>
          <ul className="help-list">
            <li><b>Ctrl/Cmd + K</b> — Open this panel</li>
            <li><b>g</b> then <b>r</b> — Jump to responses</li>
            <li><b>W</b> — Toggle Wild Mode</li>
            <li>Use the bottom-right launcher for quick actions</li>
          </ul>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setHelpOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Snackbars */}
      <Snackbar
        open={toast.open}
        autoHideDuration={2200}
        onClose={closeToast}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        TransitionComponent={Zoom}
      >
        <Alert onClose={closeToast} severity="info" variant="filled">{toast.msg}</Alert>
      </Snackbar>

      {/* Your existing Modal (unchanged logic; just kept here for stacking) */}
      <Modal open={open} onClose={handleClose}>
        <div
          style={{
            backgroundColor: "lightgray",
            border: "2px solid darkgray",
            borderRadius: "10px",
            width: "90%",
            height: "80%",
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            overflowY: "auto",
            zIndex: 1000,
            padding: "20px",
            boxSizing: "border-box",
          }}
        >
          <div>
            <FormControl fullWidth margin="normal">
              <InputLabel id="document-id-selector-label">Question ID</InputLabel>
              <Select
                labelId="document-id-selector-label"
                value={selectedId}
                label="Question ID"
                onChange={handleIdChange}
              >
                {documentIds.map((id) => (
                  <MenuItem key={id} value={id}>
                    {id}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel id="question-selector-label">Selected Question</InputLabel>
              <Select
                labelId="question-selector-label"
                value={selectedQuestion}
                label="Selected Question"
                onChange={handleQuestionChange}
              >
                {questions.map((q, i) => (
                  <MenuItem key={i} value={q}>
                    {q}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <h4>Selected ID: {selectedId}</h4>
          <h4>Selected Question: {selectedQuestion}</h4>

          {Object.entries(documentData).map(([key, value]) => (
            <div key={key}>
              <h4>{key}</h4>
              <TextField
                fullWidth
                multiline
                rows={4}
                value={value}
                onChange={(e) =>
                  setDocumentData({
                    ...documentData,
                    [key]: e.target.value,
                  })
                }
              />
            </div>
          ))}

          <div className="button-Box">
            <Button onClick={handleSave}>Save</Button>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleDelete}>Delete</Button>
            <Button onClick={handleClose}>Close</Button>
          </div>
        </div>
      </Modal>
    </div>
  );

}

export default Admin;
